import { Modal } from '@systemeio/ui'
import React from 'react'
import { Loader } from 'shared/components/loader'

interface EmailPreviewModalProps {
  preview: string
  subject: string
  opened: boolean
  onClose: () => void
}

export function EmailPreviewModal({ preview, subject, opened, onClose }: EmailPreviewModalProps) {
  return (
    <Modal isCentered opened={opened} onClose={onClose} title={subject} isFetching={!preview}>
      {!preview ? (
        <div className="flex justify-center">
          <Loader />
        </div>
      ) : (
        <iframe style={{ width: '100%', height: 'max(600px, 75vh)' }} srcDoc={preview} />
      )}
    </Modal>
  )
}
